module.exports = __webpack_public_path__ + "img/zhihuiyuanqu.1ba3641e.jpg";